import { Field, FieldHint, FieldLabel, Input } from '@repo/ui-web';

export function FieldShowcase() {
  return (
    <div className="space-y-4">
      <Field>
        <FieldLabel htmlFor="ds-field-email">Email address</FieldLabel>
        <Input id="ds-field-email" placeholder="name@company.com" showClearButton={false} />
        <FieldHint>We will never share your email.</FieldHint>
      </Field>
    </div>
  );
}
